/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import {
  linkType,
  imageType,
  colourThemeType,
  backgroundImageWidthType,
} from '../../propTypes';
import CtaButton from '../CtaButton';
import FullViewportContainer from '../FullViewportContainer';
import ResponsiveImage from '../ResponsiveImage';
import {
  getSliceCtaAlignment,
  getSliceRichText,
  getSliceCta,
  getSliceRichTextTitle,
  getSliceTitleAlignment,
  getSliceTextAlignment,
  getSliceRichTextColumns,
  getSliceNoBottomMargin,
  getSliceBottomMarginSize,
  getSliceRichTextGridSize,
  getSliceContent,
  getSliceBackgroundImage,
  getSliceBackgroundImageWidth,
  getSliceColourTheme,
} from '../../selectors';
import get from '../../helpers/get';
import style from './styleRichtext';
import { sliceColourTheme } from '../../styles/theme';

const Richtext = ({
  id, className, classes, html, link, ctaAlignment,
  textAlignment, title, titleAlignment, gridSize,
  backgroundImage,
}) => (
  <FullViewportContainer>
    <div className={cn(classes.wrapper, className)}>
      {backgroundImage && (
        <ResponsiveImage
          className={classes.backgroundImage}
          images={backgroundImage.sizes}
          alt={backgroundImage.alt}
          blur={backgroundImage.blur}
        />
      )}
      <div id={id} className={cn(classes.container, classes[gridSize])}>
        {title && (
          <div
            className={titleAlignment}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        <div
          className={cn(classes.textContainer, textAlignment)}
          dangerouslySetInnerHTML={{ __html: html }}
        />
        {link && link.text && (
          <div className={cn(classes.ctaContainer, ctaAlignment)}>
            <CtaButton link={link} />
          </div>
        )}
      </div>
    </div>
  </FullViewportContainer>
);

Richtext.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  html: PropTypes.string,
  id: PropTypes.string,
  textAlignment: PropTypes.string,
  title: PropTypes.string,
  titleAlignment: PropTypes.string,
  link: linkType,
  ctaAlignment: PropTypes.string,
  gridSize: PropTypes.string,
  backgroundImage: imageType,
  // eslint-disable-next-line react/no-unused-prop-types
  backgroundImageWidth: backgroundImageWidthType, // used in the styles
  // eslint-disable-next-line react/no-unused-prop-types
  colourTheme: colourThemeType, // used in the styles
};

Richtext.defaultProps = {
  className: undefined,
  link: undefined,
  html: undefined,
  id: undefined,
  ctaAlignment: undefined,
  textAlignment: undefined,
  title: undefined,
  titleAlignment: undefined,
  gridSize: undefined,
  backgroundImage: undefined,
  backgroundImageWidth: 'Edge-to-edge',
  colourTheme: sliceColourTheme.white,
};

const mapStateToProps = (state, { sliceId }) => ({
  id: get(getSliceContent(state, sliceId), ['id']),
  html: getSliceRichText(state, sliceId),
  textAlignment: getSliceTextAlignment(state, sliceId),
  link: getSliceCta(state, sliceId),
  ctaAlignment: getSliceCtaAlignment(state, sliceId),
  title: getSliceRichTextTitle(state, sliceId),
  titleAlignment: getSliceTitleAlignment(state, sliceId),
  columns: getSliceRichTextColumns(state, sliceId),
  noBottomMargin: getSliceNoBottomMargin(state, sliceId),
  bottomMarginSize: getSliceBottomMarginSize(state, sliceId),
  gridSize: getSliceRichTextGridSize(state, sliceId),
  backgroundImage: getSliceBackgroundImage(state, sliceId),
  backgroundImageWidth: getSliceBackgroundImageWidth(state, sliceId),
  colourTheme: sliceColourTheme[getSliceColourTheme(state, sliceId)],
});

export default compose(
  connect(mapStateToProps),
  injectSheet(style),
)(Richtext);
